/**
 * 与业务无关
 */

export const isDev = () => {
	return typeof process !== undefined && process.env.NODE_ENV === 'development'
}

export const getType = src => {
	return Object.prototype.toString.call(src).split(' ').slice(-1)[0].slice(0, -1).toLowerCase()
}

export const isObject = src => {
	return getType(src) === 'object'
}

export const isFunction = src => {
	return getType(src) === 'function'
}

export const isArray = src => {
	return getType(src) === 'array'
}

export const isEmptyObject = src => {
	return getObjectLength(src) === 0
}

export const getNow = _ => {
	let date = new Date()
	let [localeTime, milliSeconds] = [date.toLocaleTimeString(), date.getMilliseconds()]
	let time = `${localeTime} ${milliSeconds}ms`
	return time
}

export const getDouble = str => {
	let _str = str + ''
	return _str.length > 1 ? _str : `0${_str}`
}

export const isToday = timestamp => {
	return new Date(timestamp).toDateString() === (new Date).toDateString()
}

export const getTime = timestamp => {
	let time = new Date(+timestamp)
	let timeArr = [
		time.getFullYear(),
		(time.getMonth() + 1),
		time.getDate(),
		time.getHours(),
		time.getMinutes(),
		time.getSeconds()
	].map(item => getDouble(item))

	return [timeArr.slice(0, 3).join('/'), timeArr.slice(3).join(':')].join(' ')
}

export const getShortTime = timestamp => {
	let istoday = isToday(timestamp)
	let time = new Date(+timestamp)
	let timeArr = istoday
		? [time.getHours(), time.getMinutes()]
		: [time.getFullYear(), (time.getMonth() + 1), time.getDate()]
	timeArr = timeArr.map(item => getDouble(item))
	return timeArr.join(istoday ? ':' : '/')
}

export const logPrint = (des, tem) => {
	if (!isDev()) return
	if (!tem) {
		tem = des
		des = 'print'
	}
	let now = getNow()
	console.log(`print ====== start ${now}`)
	console.log(des, tem)
	console.log(`print ====== end ${now}`)
}

export const deepCopy = (src, res) => {
	let result = {}
	for (let key of Object.keys(src)) {
		let item = src[key]
		if (isObject(item)) {
			result[key] = deepCopy(item, res)
		} else {
			result[key] = item
		}
	}
	if (isFunction(res)) {
		return res(result)
	} else {
		return result
	}
}

export const stringToJson = src => {
	try {
		let res = JSON.parse(src)
		if (isObject(res)) {
			return res
		} else {
			return src
		}
	} catch (e) {
		// console.error('stringToJson err', src)
		return src
	}
}

export const jsonToString = src => {
	return deepCopy(src, res => {
		try {
			return JSON.stringify(res)
		} catch (e) {
			console.error('jsonToString err', res)
		}
	})
}

export const getObjectLength = src => {
	return Object.keys(src).length
}

export const lazyExec = (context, time = 300) => {
	let timer = null

	return _ => {
		clearTimeout(timer)
		timer = setTimeout(context, time)
	}
}

export const isMac = () => {
	let reg = /macintosh|mac os x/i
	return reg.test(window.navigator.userAgent)
}

export const routerController = function ({ state, exact_state }) {
	if (state == 'interview') {
		switch (exact_state) {
			case 'unassigned':
				this.$router.replace('/book_interview?status=unassigned')
				break
			case 'assigned':
				this.$router.replace('/interview?status=assigned')
				break
			case 'no show':
				// 未出席 直接失败 只能联系面试官
				this.$router.replace('/interview_result?status=noshow')
				break
			case 'canceled':
				this.$router.replace('/interview?status=canceled')
				break
			case 'rescheduled':
				this.$router.replace('/interview?status=rescheduled')
				break
			case 'failed':
				this.$router.replace('/interview_result?status=failed')
				break
			case 'passed':
				this.$router.replace('/interview_pass?status=passed')
				break
			default:
				console.log('interview流程匹配错误')
		}

		return
	}

	if (state == 'tpg') {
		switch (exact_state) {
			case 'unassigned':
				this.$router.replace('/book_tpg?status=unassigned')
				break
			case 'canceled':
				this.$router.replace('/tpg?status=canceled')
				break
			// 未出席 直接失败 只能联系面试官
			case 'no show':
				this.$router.replace('/tpg_result?status=noshow')
				break
			case 'assigned':
				this.$router.replace('/tpg?status=assigned')
				break
			case 'rescheduled':
				this.$router.replace('/tpg?status=rescheduled')
				break
			case 'failed':
				this.$router.replace('/tpg_result?status=failed')
				break
			default:
				console.log('tpg流程匹配错误')
		}

		return
	}

	if (state == 'new_demo') {
		switch (exact_state) {
			case 'unassigned':
				this.$router.replace('/book_demo?status=unassigned')
				break
			case 'canceled':
				this.$router.replace('/demo?status=canceled')
				break
			// 未出席 直接失败 只能联系面试官
			case 'no show':
				this.$router.replace('/demo_result?status=noshow')
				break
			case 'assigned':
				this.$router.replace('/demo?status=assigned')
				break
			case 'rescheduled':
				this.$router.replace('/demo?status=rescheduled')
				break
			case 'failed':
				this.$router.replace('/demo_result?status=failed')
				break
			default:
				console.log('demo流程匹配错误')
		}

		return
	}

	if (state == 'onboarding') {
		switch (exact_state) {
			case 'info':
				this.$router.replace('/personal_profile/personal_in')
				break
			case 'qualific':
				this.$router.replace('/personal_profile/personal_qa')
				break
			case 'paymode':
				this.$router.replace('/personal_profile/payment')
				break
			case 'video':
				this.$router.replace('/personal_profile/on_board')
				break
			case 'sa':
				this.$router.replace('/personal_profile/sign_sa')
				break
			default:
				console.log('onboardoing service error!')
		}

		return
	}

	if (state == 'end') {
		switch (exact_state) {
			case 'upased':
				this.$router.replace('/online_pending')
				break
			case 'success':
				this.$router.replace('/get_started')
				break
			case 'failed':
				this.$router.replace('/online_failed')
				break
			case 'assigned':
				window.location.href = urls.myPageLogTea
				break
			default:
				console.log('end流程返回错误.')
		}

		return
	}

	switch (state) {
		case 'fillform': // 填写表单页面
			if (exact_state) {
				// 预筛失败
				this.$router.replace(`/fillform?status=${exact_state}`)
				return
			}

			this.$router.replace('/fillform')
			break
		case 'pso': //pso页面
			this.$router.replace('/pso')
			break
		case 'updatepwd': //修改密码页面
			this.$router.replace('/resetcode')
			break
		case 'end': //流程结束
			this.$router.replace('/get_started')
			break
		default:
			//均不匹配
			console.log('大流程匹配失败!')
	}
}

export const urls = {
	ssoLogin: 'http://sso.51talk.com/sso/admin?client=13&lang=english',
	ssoUsLogin: 'http://sso.us.51talk.com/sso/admin?client=13&lang=english',
	ssoLogout: 'http://sso.51talk.com/sso/logout?client=13&lang=english',
	myPageLogTea: 'http://mypage.51talk.com/admin/main.php?flag=trues&log_tea=tea',
	goLogout: 'https://login.51talk.com/sso/logout?client=13',
	landingUsaRegister: 'https://mypage.51talk.com/ph/landing_usa_register.php',
	naFaq: 'https://www.51talk.com/na/faq.php',
	
	// 第三方
	trainingModulesLink: 'https://elearning.easygenerator.com/35334358-aa1c-4ee6-a579-251db1020ba8',
	// pdf
	zoomPdfLink: '//static.51talk.com/text/ImmediatelyExperience/zoom.pdf?v=65738933',
	interviewPdfLink: '//static.51talk.com/text/ImmediatelyExperience/nademomaterial_20180818.pdf',
	// 视频地址
	psoVideoLink: '//static.51talk.com/upload/video/Orientation%20Video-PSO.mp4',
	// 文件下载地址
	acMacDownloadLink: 'https://ac.51talk.com/PcAc/version/51Talk-MAC.1.15.0.1.dmg',
	acPcDownloadLink : 'https://ac.51talk.com/PcAc/version/51Talk-AC.2.15.0.72.exe'
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js